import { factory } from '../../../utils/apiThunkFactory'

export const stopUserSessionAndJoinRoom = factory.put('productivitySession/stopUserSessionAndJoinRoom', '/api/users/stopAndJoin')